import { TDR } from 'tdr-common';

export const getPatioSection = (tables: TDR.Table[]) => (
	tables.find((table) => table.isPatio)
);